import type React from "react";

interface PlaceholderPageProps {
	title: string;
}

const PlaceholderPage: React.FC<PlaceholderPageProps> = ({ title }) => {
	return (
		<div className="card card-xl-stretch mb-xl-8">
			<div className="card-body d-flex flex-column justify-content-center text-center p-15">
				<div className="mb-10">
					<img
						src="/media/illustrations/sigma-1/17.png"
						alt="Coming Soon"
						className="mw-100 h-200px mb-10"
						onError={(e) => {
							(e.target as HTMLImageElement).src =
								"https://preview.keenthemes.com/metronic8/demo1/assets/media/illustrations/sigma-1/17.png";
						}}
					/>
				</div>
				<h1 className="fw-bold text-gray-900 mb-5">{title}</h1>
				<p className="fw-semibold text-gray-400 fs-4 mb-10">
					We're working hard to bring you the {title} module. <br />
					Stay tuned for updates!
				</p>
				<div className="d-flex flex-center">
					<button
						onClick={() => window.history.back()}
						className="btn btn-primary"
					>
						Go Back
					</button>
				</div>
			</div>
		</div>
	);
};

export default PlaceholderPage;
